import { render, staticRenderFns } from "./SortingEdit.vue?vue&type=template&id=13f247e3"
import script from "./SortingEdit.vue?vue&type=script&lang=ts"
export * from "./SortingEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports